import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";

import { Navigate, useLocation } from "react-router-dom"
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import { Admin } from "./pages/Admin";
import "./services/AxiosInterceptors";
import { Layout } from "./fragments/Layout";
import { MyPicks } from "pages/MyPicks";
import { Results } from "pages/Results";
import { History } from "pages/History";
import UserService from "services/UserService";
import { UserProfile } from "pages/UserProfile";
import AllPicks from "pages/AllPicks";
import { Home } from "pages/Home";



const PrivateRoute = (props: { children: React.ReactNode, requiredRole?: string }): JSX.Element => {
  const { children } = props

  // Up to you specific app to decide how to get this value
  const user = UserService.getUserInfo();
  const isLoggedIn =  !!user && (!props.requiredRole || user.roles.indexOf(props.requiredRole) >= 0);
  const location = useLocation()

  return isLoggedIn ? (
    <>{children}</>
  ) : (
    <Navigate
      replace={true}
      to="/login"
      state={{ from: `${location.pathname}${location.search}` }}
    />
  )
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <div>Error</div>,
    children: [
      { index: true, element: <PrivateRoute><Home /></PrivateRoute> },
      { path: "/login", element: <Login /> },
      { path: "/register", element: <Login isRegistering={true} /> },
      { path: "/logout", element: <Login isLogout={true} /> },
      { path: "/forgot-password", element: <ForgotPassword /> },
      { path: "/reset-password", element: <ResetPassword /> },
      { path: "/admin", element: <PrivateRoute requiredRole="Admin"><Admin /></PrivateRoute> },
      { path: "/admin/:tabName", element: <PrivateRoute><Admin /></PrivateRoute> },
      { path: "/picks/all", element: <PrivateRoute><AllPicks /></PrivateRoute> },
      { path: "/picks", element: <PrivateRoute><MyPicks /></PrivateRoute> },
      { path: "/results", element: <PrivateRoute><Results /></PrivateRoute> },
      { path: "/history", element: <PrivateRoute><History /></PrivateRoute> },
      { path: "/profile", element: <PrivateRoute><UserProfile /></PrivateRoute> },
    ],
  },
]);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
